(() => {
  const cleanBenefits = () => {
    const root = document.querySelector('.osea-benefits');
    if (!root) return;
    [...root.querySelectorAll('.osea-benefit')].forEach((card) => {
      const title = card.querySelector('strong')?.textContent.trim().toLowerCase();
      if (title === 'facturación' || title === 'facturacion') card.remove();
    });
    [...root.querySelectorAll('.osea-benefit')].forEach((card, index) => {
      card.style.display = 'flex';
      const icon = card.querySelector('.osea-benefit__icon');
      if (icon) icon.textContent = String(index + 1).padStart(2, '0');
    });
  };

  const cleanHomeCopy = () => {
    const copy = document.querySelector('.osea-hero-slide:first-child .osea-hero-copy > p');
    if (copy && /facturaci[oó]n/i.test(copy.textContent)) {
      copy.textContent = 'Papel higiénico, toallas, jabones y papelería con precios claros, atención comercial directa y compra por volumen.';
    }
  };

  const cleanTrustStrip = () => {
    document.querySelectorAll('.osea-trust-strip__item').forEach((item) => {
      if (/^facturaci[oó]n$/i.test(item.textContent.trim())) item.remove();
    });
  };

  const removeBusinessPicker = () => {
    document.querySelectorAll('[data-osea-business-picker]').forEach((section) => section.remove());
  };

  const addTrustRoll = () => {
    const strip = document.querySelector('.osea-trust-strip');
    if (!strip || strip.querySelector('.osea-trust-runners')) return;

    if (!document.querySelector('#oseaTrustRollStyles')) {
      const style = document.createElement('style');
      style.id = 'oseaTrustRollStyles';
      style.textContent = `
        .osea-trust-strip{
          position:relative;
          isolation:isolate;
          overflow:hidden;
        }
        .osea-trust-strip__viewport{
          position:relative;
          z-index:3;
        }
        .osea-trust-runners{
          position:absolute;
          inset:0;
          z-index:1;
          pointer-events:none;
          overflow:hidden;
        }
        .osea-trust-runner{
          --runner-size:86px;
          position:absolute;
          left:0;
          top:50%;
          width:var(--runner-size);
          height:48px;
          opacity:.30;
          filter:drop-shadow(0 5px 8px rgba(23,59,77,.10));
          transform:translate3d(calc(100vw + 150px),-50%,0);
          animation:oseaTrustRollTravel 14s linear infinite;
          animation-delay:calc(var(--i) * -2s);
          will-change:transform;
        }
        .osea-trust-runner:nth-child(2n){--runner-size:78px;opacity:.24}
        .osea-trust-runner:nth-child(3n){--runner-size:94px;opacity:.34}
        .osea-trust-runner__bounce{
          width:100%;
          height:100%;
          animation:oseaTrustRollBounce .62s cubic-bezier(.34,.08,.56,1) infinite alternate;
          transform-origin:center bottom;
          will-change:transform;
        }
        .osea-trust-runner:nth-child(2n) .osea-trust-runner__bounce{animation-duration:.72s}
        .osea-trust-runner:nth-child(3n) .osea-trust-runner__bounce{animation-duration:.54s}
        .osea-trust-runner svg{
          display:block;
          width:100%;
          height:100%;
          overflow:visible;
        }
        .osea-trust-roll__wheel{
          transform-box:fill-box;
          transform-origin:center;
          animation:oseaTrustRollSpin .78s linear infinite;
        }
        .osea-trust-roll__paper-tail{
          transform-box:fill-box;
          transform-origin:left center;
          animation:oseaTrustPaperWave .48s ease-in-out infinite alternate;
        }
        .osea-trust-roll__inner-ring{
          transform-box:fill-box;
          transform-origin:center;
          animation:oseaTrustInnerSpin 1.18s linear infinite reverse;
        }
        @keyframes oseaTrustRollTravel{
          from{transform:translate3d(calc(100vw + 150px),-50%,0)}
          to{transform:translate3d(-180px,-50%,0)}
        }
        @keyframes oseaTrustRollBounce{
          0%{transform:translateY(5px) rotate(3deg) scaleX(1.03) scaleY(.96)}
          45%{transform:translateY(-7px) rotate(-3deg) scaleX(.98) scaleY(1.03)}
          100%{transform:translateY(2px) rotate(2deg) scaleX(1.01) scaleY(.99)}
        }
        @keyframes oseaTrustRollSpin{to{transform:rotate(360deg)}}
        @keyframes oseaTrustInnerSpin{to{transform:rotate(360deg)}}
        @keyframes oseaTrustPaperWave{
          from{transform:rotate(-4deg) skewY(-2deg)}
          to{transform:rotate(5deg) skewY(3deg)}
        }
        @media(max-width:760px){
          .osea-trust-runner{
            --runner-size:68px;
            height:40px;
            opacity:.24;
            animation-duration:12s;
            animation-delay:calc(var(--i) * -1.72s);
          }
          .osea-trust-runner:nth-child(2n){--runner-size:62px}
          .osea-trust-runner:nth-child(3n){--runner-size:74px}
        }
        @media(prefers-reduced-motion:reduce){
          .osea-trust-runners{display:none!important}
        }
      `;
      document.head.appendChild(style);
    }

    const runners = document.createElement('div');
    runners.className = 'osea-trust-runners';
    runners.setAttribute('aria-hidden', 'true');

    const rollMarkup = `
      <div class="osea-trust-runner__bounce">
        <svg viewBox="0 0 112 54" xmlns="http://www.w3.org/2000/svg" focusable="false">
          <g class="osea-trust-roll__paper-tail">
            <path d="M46 18H102V36L98 40L94 36L90 40L86 36L82 40L78 36L74 40L70 36L66 40L62 36L58 40L54 36L50 40H46Z" fill="#FFFFFF" stroke="#79CFEA" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M53 23H96M53 28H91M53 33H87" stroke="#BFE8F7" stroke-width="1.35" stroke-linecap="round"/>
          </g>
          <g class="osea-trust-roll__wheel">
            <circle cx="32" cy="27" r="20" fill="#FFFFFF" stroke="#38A9D6" stroke-width="2.1"/>
            <circle cx="32" cy="27" r="15.5" fill="none" stroke="#DDF3FA" stroke-width="2"/>
            <circle cx="32" cy="27" r="11.5" fill="none" stroke="#BFE8F7" stroke-width="1.6" stroke-dasharray="2.5 2.5"/>
            <g class="osea-trust-roll__inner-ring">
              <circle cx="32" cy="27" r="7.5" fill="#DDF3FA" stroke="#38A9D6" stroke-width="1.8"/>
              <path d="M27 23.5c2.8-2.6 7.6-1.8 9.2 1.7M37 29.5c-2.6 3.1-7.9 3.2-10.2-.1M32 19.5v4M32 30.5v4" fill="none" stroke="#79CFEA" stroke-width="1.45" stroke-linecap="round"/>
              <circle cx="32" cy="27" r="3" fill="#FFFFFF"/>
            </g>
            <path d="M32 8.5V13M50.5 27H46M32 45.5V41M13.5 27H18" stroke="#BFE8F7" stroke-width="2" stroke-linecap="round"/>
          </g>
        </svg>
      </div>`;

    for (let i = 0; i < 7; i += 1) {
      const runner = document.createElement('div');
      runner.className = 'osea-trust-runner';
      runner.style.setProperty('--i', i);
      runner.innerHTML = rollMarkup;
      runners.appendChild(runner);
    }

    strip.appendChild(runners);
  };

  const protectAnnouncementCopy = () => {
    const target = document.querySelector('.osea-announcement__row > span:first-child');
    if (!target) return;
    const replace = () => {
      if (/facturaci[oó]n para empresas/i.test(target.textContent)) {
        target.textContent = 'Atención comercial directa';
      }
    };
    replace();
    const observer = new MutationObserver(replace);
    observer.observe(target, { childList: true, characterData: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    cleanBenefits();
    cleanHomeCopy();
    cleanTrustStrip();
    addTrustRoll();
    protectAnnouncementCopy();
    removeBusinessPicker();
    setTimeout(() => {
      cleanTrustStrip();
      addTrustRoll();
      removeBusinessPicker();
    }, 120);
  });
})();
